import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { useAlert } from "../../../AlertContext";
import { AuthContext } from "../../../AuthContext";
import { InfoContext } from "../../../InfoContext";
import { UserContext } from "../../../UserContext";

import LoadingCircle from "../../../LoadingCircle";

const server_url = process.env.REACT_APP_BACKEND_URL;

const JoinTeamForm: React.FC = () => {
  const [selectedTeamId, setSelectedTeamId] = useState("");
  const { teams, isLoading, getTeamById } = useContext(InfoContext);
  const { fetchUserData } = useContext(UserContext);
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const { session } = useContext(AuthContext);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!session) {
      showAlert("error", "Invalid session. Please try logging in again!!");
      navigate("/login");
      return;
    }
    const access_token = session.access_token;

    try {
      const response = await axios.post(`${server_url}/joinTeam`, {
        access_token: access_token,
        team_id: selectedTeamId,
      });
      if (response.data.status) {
        showAlert("success", "Your request to join the team was successful!");
        await fetchUserData();
      } else {
        showAlert("error", response.data.error);
      }
    } catch (error) {
      console.error("Error joining team:", error);
      showAlert("error", "An error occurred while trying to join the team.");
    }
  };

  return (
    <div className="max-w-md p-6 bg-white/10 rounded-xl shadow-lg w-full">
      <h2 className="text-3xl font-semibold text-white mb-6">Join a Team</h2>
      <h3 className="text-white/80 text-md mb-6">
        Select a team you wish to join from the list below.
      </h3>
      {isLoading ? (
        <LoadingCircle />
      ) : (
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="teamSelect"
              className="block text-white/90 text-md mb-1"
            >
              Teams *
            </label>
            <select
              id="teamSelect"
              value={selectedTeamId}
              onChange={(e) => setSelectedTeamId(e.target.value)}
              className="w-full px-3 py-2 bg-zinc-200 text-zinc-900 placeholder-zinc-500 rounded-xl focus:outline-none focus:shadow-[0_0_10px_black]"
              required
            >
              <option value="" disabled>
                Select a team
              </option>
              {teams.map((team) => (
                <option key={team.team_id} value={team.team_id}>
                  {team.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <button
              type="submit"
              className="w-full py-2 px-4 rounded-xl font-semibold text-white bg-blue-500 hover:bg-blue-600 focus:ring-2"
            >
              Join Team
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default JoinTeamForm;
